export default "__VITE_ASSET__BhyQobkc__"